import { render, staticRenderFns } from "./ConversationPreview.vue?vue&type=template&id=2fdbcff1&scoped=true&"
import script from "./ConversationPreview.vue?vue&type=script&lang=ts&"
export * from "./ConversationPreview.vue?vue&type=script&lang=ts&"
import style0 from "./ConversationPreview.vue?vue&type=style&index=0&id=2fdbcff1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdbcff1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAvatar,VBadge,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
